'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'user-group-simple';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e603';
var svgPathData = 'M176 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-176a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM152 336C94.6 336 48 382.6 48 440l0 16c0 13.3-10.7 24-24 24S0 469.3 0 456l0-16c0-83.9 68.1-152 152-152l48 0c83.9 0 152 68.1 152 152l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-57.4-46.6-104-104-104l-48 0zM464 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-176a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm36.8 416c50.4 0 91.2-40.8 91.2-91.2 0-2.6-2.2-4.8-4.8-4.8l-216.3 0c-10.8-17.7-24.3-33.6-39.8-47.1 3.2-.6 6.4-.9 9.8-.9l246.4 0c29.2 0 52.8 23.6 52.8 52.8 0 76.9-62.3 139.2-139.2 139.2l-73.6 0c-10.4 0-20.5-1.1-30.2-3.3 2-6.6 3-13.5 3-20.7l0-16c0-4.1-.1-8.2-.4-12.2 8.7 2.8 18 4.2 27.6 4.2l73.6 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserGroupSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;